<template>
  <div v-if="map"></div>
</template>
<script>
import 'leaflet.markercluster';
import L from 'leaflet';
import blackPinIcon from '@/assets/images/black-pin.png';

export default {
  name: 'MapCluster',
  props: {
    map: { type: Object, required: true },
    markers: { type: Array, required: true } // [{ lat, lng, popupText }]
  },
  data() {
    return {
      markerCluster: null,
    };
  },
  mounted() {
    this.initCluster();
  },
  methods: {
    initCluster() {
      // Clear old if any
      if (this.markerCluster) {
        this.map.removeLayer(this.markerCluster);
      }

      const group = L.featureGroup();
      this.markerCluster = L.markerClusterGroup();

      this.markers.forEach((marker) => {
        if (
          !marker ||
          typeof marker.lat !== 'number' ||
          typeof marker.lng !== 'number'
        ) {
          console.warn('Invalid marker skipped:', marker);
          return;
        }

        const {
          lat,
          lng,
          popupText,
          markerConfig = {}
        } = marker;

        try {
          const leafletMarker = L.marker([lat, lng], {
            icon: this.getCustomIcon(markerConfig.iconUrl)
          });

          if (popupText) {
            leafletMarker.bindPopup(popupText, markerConfig.popupConfig);
          }

          this.markerCluster.addLayer(leafletMarker);
          group.addLayer(leafletMarker);
        } catch (e) {
          console.warn('Failed to add marker:', marker, e);
        }
      });

      if (group.getLayers().length > 0) {
        this.map.addLayer(this.markerCluster);
        this.map.fitBounds(group.getBounds().pad(0.2));
      } else {
        console.warn('No valid markers to display on map.');
      }
    },

    getCustomIcon(iconUrl) {
      return L.icon({
        iconUrl: iconUrl || require('leaflet/dist/images/marker-icon.png'), // adjust path
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowUrl: iconUrl ? '' : require('leaflet/dist/images/marker-shadow.png'),
        shadowSize: iconUrl ? [] : [41, 41],
      });
    },

    clearCluster() {
      if (this.markerCluster) {
        this.map.removeLayer(this.markerCluster);
        this.markerCluster = null;
      }
    },
  },
  watch: {
    markers: {
      handler() {
        this.initCluster();
      },
      deep: true
    }
  }
};
</script>
